import {Team} from "../../api/Model";
import React, {useEffect, useRef} from "react";
import {Stack, Typography} from "@mui/material";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

export function TeamPathBox({teamPath}: { teamPath: Team[] }) {
    const stackRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (stackRef.current) {
            stackRef.current.scrollLeft = stackRef.current.scrollWidth - stackRef.current.clientWidth;
        }
    }, []);

    return (
        <Stack
            ref={stackRef}
            direction="row"
            spacing={0.5}
            alignItems="center"
            width="100%"
            sx={{
                overflow: 'hidden',
                scrollbarWidth: 'none',
            }}
        >
            {teamPath.map((team, index) => (
                <React.Fragment key={team.id}>
                    {index > 0 && <ChevronRightIcon fontSize="small" color="disabled"/>}
                    <Typography variant="body1" sx={{textWrap: 'nowrap'}}>
                        {team.name}
                    </Typography>
                </React.Fragment>
            ))}
        </Stack>
    );
}
